/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-06-15 14:57:17
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-08-04 15:54:41
 * @FilePath: /unifyxp-v2-store-portal/src/constrains/DraggableModules/ContentGroup/ModulesGenerator/Video.ts
 */
import { ActionType } from 'src/types/common/common';

import {
  //ProductList,
  //   LongCanvas,
  //   Text,
  //   Text,
  //   ProductGridDisplay,
  Video,
  //   ListAdaptor,
} from 'src/constrains/DraggableModules/Components';

const VideoFunctions = ({
  onDynamicChange,
  onStaticChange,
  onModuleTypeChange,
}) => {
  const handleOnVideoStaticChange = (id, data) => {
    if (onStaticChange) {
      onStaticChange({
        type: ActionType.modify,
        id,
        data,
      });
    }
  };
  return {
    handleOnVideoStaticChange,
    //  handleOnTextModuleTypeChange,
  };
};
const generateVideo = ({
  onDynamicChange,
  onStaticChange,
  onModuleTypeChange,
  disabled,
}) => {
  const { handleOnVideoStaticChange } = VideoFunctions({
    onDynamicChange,
    onStaticChange,
    onModuleTypeChange,
  });
  return {
    component: Video,
    props: {
      onStaticChange: handleOnVideoStaticChange,
      disabled,
    },
  };
};
export { generateVideo };
